/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AppIconType {
    BlackArrowSolid = 0,
    LanguageSolid = 1,
    CancelRoundedSolid = 2,
    CancelSolid = 3,
    AcceptSolid = 4,
    Barcode = 5,
    Number123Solid = 6,
    HomeSolid = 7,
    PhoneSolid = 8,
    Cash = 9,
    Card = 10,
    Check = 11,
    Error = 12,
    Pencil = 13,
    CircleArrowRight = 14,
    Cart = 15,
    Delete = 16,
    Minus = 17,
    Plus = 18,
    CheckSolid = 19,
    XSolid = 20,
    ChevronDown = 21,
    PrintReceipt = 22,
    Sms = 23,
    EmailAttahchment = 24,
    MiniNo = 25,
    RiInboxUnarchiveLine = 26,
    MdPhoneInTalk = 27,
}
